import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Permissions } from '../../../../shared/auth/constants/permissions';
import { useHasPermission } from '../../../Session';
import { SaleTransactionStage } from '../../../api';
import OutlinedDatePickerField from '../../../components/fields/OutlinedDatePickerField';
import useCompanyRuntimeSettings from '../../../utilities/useCompanyRuntimeSettings';

export type HandoverFormProps = {
    currentStage?: SaleTransactionStage;
};

const HandoverForm = ({ currentStage }: HandoverFormProps) => {
    const { t } = useTranslation(['saleTransactionsPage', 'common']);
    const canUpdateTargetHandoverDate = useHasPermission(Permissions.SALES_TRANSACTION_UPDATE_TARGET_HANDOVER_DATE);
    const { datePickerFormat } = useCompanyRuntimeSettings();

    return (
        <Grid spacing={2} container>
            <Grid xs={12} item>
                <OutlinedDatePickerField
                    color="secondary"
                    disabled={!canUpdateTargetHandoverDate}
                    format={datePickerFormat}
                    label={t('saleTransactionsPage:handover.targetHandoverDate')}
                    name="handover.targetHandoverDate"
                    placeholder={t('saleTransactionsPage:handover.targetHandoverDate')}
                    required
                />
            </Grid>
        </Grid>
    );
};

export default HandoverForm;
